module.exports = __webpack_public_path__ + "img/22.ff905418.png";